import ThemeToggle from '@/core/components/theme-toggle';
import ChooseLanguageRegion from '@/core/components/modal/modal-topbar/choose-language-region';
import ChooseRegionProvider from '@/providers/choose-region/provider';

export default function SidebarSettings() {
  return (
    <div className="sidebar-settings">
      <ChooseRegionProvider>
        <ChooseLanguageRegion />
      </ChooseRegionProvider>
      <ThemeToggle />
    </div>
  );
}
